module.exports = __webpack_public_path__ + "static/neil-12713c45fe7e8f863574ae24afa451a5.webp";